import script from "./transition-expand.vue?vue&type=script&lang=ts&setup=true"
export * from "./transition-expand.vue?vue&type=script&lang=ts&setup=true"

import "./transition-expand.vue?vue&type=style&index=0&id=e01cd4bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@5.9.2__webpack@5.99.9_@swc+c_wdn4uuzbn7h75zdmcwelxa3jhq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e01cd4bc"]])

export default __exports__